import GiftBoxApi from '@apis/gift/GiftBoxApi';
import giftBoxQueries from '@apis/queries/giftBoxQueries';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';

const PAGE_SIZE = 20;

function useSentGiftBoxes() {
    const params = { size: PAGE_SIZE };
    const queryInfo = useInfiniteQuery({
        queryKey: giftBoxQueries.sent(params).queryKey,
        queryFn: ({ pageParam }) => GiftBoxApi.getSentGiftBoxes({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });

    return {
        ...queryInfo,
        gifts: getFlattenPageResponse(queryInfo) ?? [],
        isEmpty: getIsBlank(queryInfo),
    };
}

export default useSentGiftBoxes;
